
//Here's the api connector to communicate with the wordpress gallery endpoint:
//https://localhost/cms-service/index.php/wp-json/gallery/v1/id/45

import { get } from '@kit/utils/APIV1.js'

export const home = async() => {
  return get(`home/id/121`)
}